module.exports = __webpack_public_path__ + "static/media/cat-lady2.3e0e7943.png";